import _ from 'lodash';
// @mui
import { Stack, useTheme } from '@mui/system';
import { Box, FormControl, TextField, Typography } from '@mui/material';
//components
import FormCreator from 'components/FormCreator';
import { fieldType, validationTypes, invalidFields, fieldsGroupType } from 'components/FormCreator/types';
//reducers
import { selectTranslations } from 'state/reducers/translation.reducers';
import { getNewConvert } from 'state/reducers/convert.reducers';
import { useAppSelector } from 'hooks/redux.hooks';
import { getCurrencies } from 'state/reducers/global.reducers';
//sections
import { FormCard } from 'theme/elements/Forms';
import { FormHeader1 } from 'theme/elements/Headers';
//constants
import { Convert, convertType } from 'constants/convert.constants';
import { option } from 'components/FormCreator/types';
import { useMemo } from 'react';
import { format, isToday, isTomorrow, isValid } from 'date-fns';

export default function ScheduleForm(props: {
  handleChange: any;
  invalidFields: invalidFields;
  selectedToday: boolean;
}) {
  const t = useAppSelector(selectTranslations);
  const convert: Convert = useAppSelector(getNewConvert);
  const prefixFields = 'page.convert.create.step.1.schedule_preferences.';
  const theme = useTheme();

  const options = useMemo(() => {
    let options: option[] = [];
    convert.optionalDates.forEach((option) =>
      options.push({ label: getFormatDay(option) + getFormatDate(option), value: option })
    );
    return options;
  }, [convert.optionalDates]);

  const cutOffTime = useMemo(() => {
    return format(new Date(convert?.cutOffTime), 'HH:mm');
  }, [convert.cutOffTime]);

  function getFormatDay(dt: string) {
    let day = '';
    if (isValid(new Date(dt))) {
      day = isToday(new Date(dt)) ? t(`${prefixFields}conversion_today.text`) + ' ' : day;
      day = isTomorrow(new Date(dt)) ? t(`${prefixFields}conversion_tomorrow.text`) + ' ' : day;
    }
    return day;
  }

  function getFormatDate(dt: string) {
    return isValid(new Date(dt)) ? format(new Date(dt), 'd.MM.yyyy') : dt;
  }

  return (
    <Box component="form" noValidate>
      <FormCard>
        <FormHeader1 title={t(`${prefixFields}title`)} text={t(`${prefixFields}text`)} />
        <Stack spacing={2}>
          <FormCreator
            initialValidation={props.invalidFields}
            name="localPayment"
            handleChange={props.handleChange}
            fieldsGroups={[
              {
                type: fieldsGroupType.col,
                fields: [
                  {
                    type: fieldType.selectBox,
                    validation: [validationTypes.requierd],
                    renderOption: (props, option) => {
                      return (
                        <Box
                          component="li"
                          {...props}
                          className=""
                          sx={{
                            padding: '8px 16px',
                            display: 'flex',
                            justifyContent: 'space-between',
                          }}
                        >
                          <Typography>
                            {getFormatDay(option.value)}
                            {getFormatDate(option.value)}
                          </Typography>
                        </Box>
                      );
                    },
                    props: {
                      required: true,
                      name: 'conversion_date',
                      options: options,
                      label: t(`${prefixFields}conversion_date.text`),
                      value: convert.conversion_date || '',
                    },
                  },
                ],
              },
            ]}
          />
          {props.selectedToday && (
            <Typography color={theme.palette.root.orange}>
              {_.replace(t('page.convert.create.step.1.cutoff_time_message.text'), '{0}', cutOffTime)}
            </Typography>
          )}
        </Stack>
      </FormCard>
    </Box>
  );
}
